import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-items',
  standalone: true,
  imports: [],
  templateUrl: './nav-items.component.html',
  styleUrl: './nav-items.component.scss'
})
export class NavItemsComponent {

}
